import React from "react";
import loader from "../../components/loader/loader";
import dateFormat from "dateformat";

const ViewAffiliate = ({ modalId, viewDetails }) => {
  const view = viewDetails ? viewDetails : "";
  return (
    <React.Fragment>
      <div
        className="modal fade"
        id={modalId}
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header border-0">
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body pt-0">
              <div className="modal-body scroll-y px-10 px-lg-15 pt-0 pb-15">
                {viewDetails && view?._id ? (
                  <form
                    id="kt_modal_new_target_form"
                    className="form fv-plugins-bootstrap5 fv-plugins-framework"
                    action="#"
                  >
                    <div className="mb-8 text-center">
                      <h1 className="mb-3 text-primary">
                        Affiliate Application
                      </h1>
                    </div>
                    <div className="separator d-flex flex-center mb-8"></div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Contact Name</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {view.contactName}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Business Name</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {view.businessName}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Email Address</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {view.email}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Phone Number</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {view.phone}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Business Type</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {view.businessType}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Fleet / Customer Size</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {view.fleetSize || "-"}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-12 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>About Their Business</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {view.message || "-"}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Status</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold text-capitalize">
                          {view.status}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Submitted On</span>
                        </label>
                        <div className="text-gray-400 fs-4 fw-bold">
                          {view.createdAt
                            ? dateFormat(view.createdAt, "mmm d, yyyy")
                            : "-"}
                        </div>
                      </div>
                    </div>
                    <div></div>
                  </form>
                ) : (
                  loader()
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ViewAffiliate;
